import {
  UPLOAD_GIFT_IMAGE,
  ADD_GIFT,
  GIFT_LIST,
  GET_META_DATA,
  SET_GIFT_DETAILS,
  PURCHASE_GIFT,
  EDIT_GIFT,
  DELETE_GIFT
} from "./action.type";
import $axios from "../../helpers/axios-instance";
import { SET_GIFT_DETAILS_MUTATION } from "./mutation.type";

export default {
  [UPLOAD_GIFT_IMAGE](context, body) {
    return new Promise((resolve, reject) => {
      $axios
        .post(
          "/gift/uploadImage",
          {
            ...body
          },
          {
            timeout: 500000
          }
        )
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  [ADD_GIFT](context, giftDetails) {
    var body = giftDetails.giftBody;
    // console.log(body)
    return new Promise((resolve, reject) => {
      $axios
        .post(
          "/gift/add/" + giftDetails.wishlistId,
          {
            ...body
          },
          {
            timeout: 500000
          }
        )
        .then(response => {
          // console.log("Add gift action");
          // console.log(response);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  [GIFT_LIST](context, params) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/gift/list/" + params.wishlistId, {
          params: {
            host: false,
            page: params.page,
            perPageLimit: params.perPageLimit,
            sortBy: params.sortBy,
            purchased: params.purchased
          }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [GET_META_DATA](context, body) {
    return new Promise((resolve, reject) => {
      $axios
        .post(
          "/gift/metaScrape/",
          {
            ...body
          },
          {
            timeout: 1000000
          }
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  [SET_GIFT_DETAILS](context, gift) {
    context.commit(SET_GIFT_DETAILS_MUTATION, gift);
  },

  [PURCHASE_GIFT](context, purchaseDetails) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/gift/purchased", {
          ...purchaseDetails
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  [EDIT_GIFT](context, giftDetails) {
    return new Promise((resolve, reject) => {
      let body = giftDetails.giftBody;
      $axios
        .put(
          "/gift/edit/" + giftDetails.giftId,
          {
            ...body
          },
          {
            timeout: 500000
          }
        )
        .then(response => {
          //   console.log(response);
            // context.commit(SET_GIFT_DETAILS_MUTATION, response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  [DELETE_GIFT](context, giftId) {
    return new Promise((resolve, reject) => {
      $axios
        .delete("/gift/delete/" + giftId)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  // [EDIT_GIFT_DETAILS](context, editedGift) {
  //     context.commit(EDIT_GIFT_DETAILS_MUTATION, editedGift);
  // }
};
